import { IPagination } from 'common/components/pagination/Pagination';
import DataTable from 'common/components/table/DataTable';
import formatAddress from 'common/services/address/format-address';
import formatDateFromMillis from 'common/services/date/formatDate';
import ChsLicenseIntermediary from 'domain/types/ChsLicenseIntermediary';
import { License } from 'domain/types/License';

interface IVacationRentalTable {
  pagination: IPagination;
  data: License[];
}

const formatIntermediaries = (ints: ChsLicenseIntermediary[]) => {
  let str = '';
  ints.forEach((i) => {
    str += i.descr + ', ';
  });
  str = str.substring(0, str.length - 2);
  return str;
};

const VacationRentalTable = (props: IVacationRentalTable) => {
  return (
    <DataTable
      columns={[
        {
          name: 'License Number',
          selector: 'licenseNum',
        },
        {
          name: 'Address',
          render: (row) => (
            <div style={{ fontSize: '1.4rem' }}>
              {formatAddress(row.address)}
              {/* ({row.room || 'Entire dwelling'}) */}
            </div>
          ),
        },
        {
          name: 'Submitted On',
          render: (row) => <div>{formatDateFromMillis(row.createdDate)}</div>,
        },
        {
          name: 'Intermediaries',
          render: (row) => (
            <div>{formatIntermediaries(row.intermediaries)}</div>
          ),
        },
        {
          name: 'Status',
          render: (row) => {
            return <div>{row.statusDescr}</div>;
          },
        },
      ]}
      data={props.data}
      keyField='id'
      pagination={props.pagination}
    />
  );
};
export default VacationRentalTable;
